export default __webpack_public_path__ + "static/media/lessons_white_icon.c58c8702.svg";